import PropTypes from 'prop-types'

const Grid = ({ children, columns = 5, gap = 10, margin = 0 }) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      gridGap: gap,
      maxWidth: '800px',
      margin: `${margin}px`,
    }}
  >
    {children}
  </div>
)

Grid.propTypes = {
  columns: PropTypes.number,
  children: PropTypes.node,
  gap: PropTypes.number,
  margin: PropTypes.number,
}


export default Grid
